import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import templateMarkup from 'raw-loader!./historical2-dashboard-view.html';
import LogiCommon from '../../../app/data-framework/logi-common';
import PreferenceService from '../../../services/preference.service';
import LoginService from "../../../services/login.service";
import DataProvider from "../../../app/data-framework/data-provider";

function HistoricalDashboard2View(params) {

    var self = this;
    self.widgetDragDropContainerOptions = {};

    self.dataProvider = DataProvider.getInstance();

    self.panels = ko.observableArray([]);
    self.fixedPanels = ko.observableArray([]);

    self.dataProvider.loadEndpointModels();
    self.dataProvider.loadFlexQueryMetadata();

    self.route = params.route;
    self.menus = params.menus;
    var link = ko.computed(() => self.route().link);
    self.currentTabFixedPanelObservable = ko.observableArray([]);

    self.currentPanelsObservable = ko.observableArray([]);
    self.subscriptions = [];

    self.tabId = ko.pureComputed(function() {
      return self.route().tabId ? self.route().tabId.toString() : '0';
    });

    self.timeZone = {
        id: _.get(LoginService.userObject, 'timezoneId', ''),
        text: _.get(LoginService.userObject, 'timezoneDisplay', '')
    };

    self.logiCommon = new LogiCommon();
    self.selectedDateRangeValues = ko.observable();

    self.urlParams = null;

    var loaded = false;

    self.viewTitle = 'My Dashboards';
    self.appId = params.appId;
    function handleRoute() {
        if (self.route().params) {
            self.urlParams = self.logiCommon.getParamsObject(self.route().params);
        }

        if (self.route().view === 'historical2-roomboard-view' ) {
            self.viewId = 'historical2roomboard';
            if (self.route().page !== 'rooms-app-view') {
              self.viewTitle = 'Workspaces';
            }
            self.shareName = 'Workspaces';
        }
        else { //if self.route().view === 'historical2-dashboard-view'
            self.viewId = 'historical2dashboard';
            self.shareName = 'Historical Dashboard';
        }

        if (!link()) {
            PreferenceService.getDateRange(self.appId).then((dateRange) => {
                self.selectedDateRangeValues({
                    startDate: moment(dateRange.startDate),
                    endDate: moment(dateRange.endDate)
                });
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        } else {
            self.dataProvider.getTokenParams(link()).then(function (tokenParams) {
                if (tokenParams) {
                    self.selectedDateRangeValues({
                        startDate: moment(tokenParams.inpStartDate, 'YYYY/MM/DD'),
                        endDate: moment(tokenParams.inpEndDate, 'YYYY/MM/DD')
                    });
                } else {
                    alert('Invalid link');
                }
                loaded = true;
                self.selectedDateRangeValues.valueHasMutated();
            });
        }
    }

    handleRoute();
    self.subscriptions.push(
        self.route.subscribe(() => {
            handleRoute();
        })
    );

    self.viewLevelOptions = ko.pureComputed(function () {
        //hierarchy, daterange, urlparamobject, dataFilter, daysPerWeek, hoursPerDay
        var result1 = self.logiCommon.GetHistoricalViewLevelOptions2(null, self.selectedDateRangeValues(), self.urlParams);
        if (loaded && result1.inpStartDate) {
            return result1; // : result1;
        }
        return null;
    }).extend({ notify: 'always' });

    self.subscriptions.push(self.viewLevelOptions.subscribe(function () {
        if (self.urlParams || !loaded || link()) {
            return;
        }
        PreferenceService.saveDateRange(self.appId, self.selectedDateRangeValues());
    }));
}

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
HistoricalDashboard2View.prototype.dispose = function () {
    var self = this;
    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });

};

export default { viewModel: HistoricalDashboard2View, template: templateMarkup };
